// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5124391c","726":"3f3bafb2"}[chunkId] + ".chunk.js";
};